import React from 'react';

function BillingView() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container-app py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Billing</h1>
        <div className="card">
          <p className="text-gray-600">Billing dashboard coming soon...</p>
        </div>
      </div>
    </div>
  );
}

export default BillingView;
